import React from 'react';
import { ChevronDown } from 'lucide-react';
import { LocationChip } from './hero/LocationChip';
import { HeroFounderTag } from './hero/HeroFounderTag';
import { HeroCTAGroup } from './hero/HeroCTAGroup';
import { HeroStats } from './hero/HeroStats';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export const HeroSection = () => (
  <section id="home" className="hero-section" data-testid="hero-section">
    <div className="hero-content">
      <LocationChip />

      <h1 className="heading-hero" data-testid="hero-headline">
        Protect, grow & blueprint your wealth
        <span style={{ color: 'var(--accent-gold)' }}> with Hooghly's trusted advisor.</span>
      </h1>

      <p
        className="heading-sub-hero"
        style={{
          fontSize: 'clamp(1.05rem, 2vw, 1.35rem)',
          fontWeight: 500,
          maxWidth: '780px',
          margin: '0 auto 2rem'
        }}
        data-testid="hero-subheadline"
      >
        Premium financial consulting for individuals & businesses — wealth management, retirement
        blueprinting and tax optimization. Fee-aware, AMFI-registered, and proudly local.
      </p>

      <HeroFounderTag />
      <HeroCTAGroup onExploreServices={() => scrollTo('services')} />
      <HeroStats />
    </div>

    <div className="scroll-indicator" onClick={() => scrollTo('about')}>
      <span style={{ fontSize: '0.825rem', fontWeight: 500 }}>Discover More</span>
      <ChevronDown size={22} className="scroll-arrow" />
    </div>
  </section>
);
